import { render, staticRenderFns } from "./FreeTourCarousel.vue?vue&type=template&id=796696c4&scoped=true"
import script from "./FreeTourCarousel.vue?vue&type=script&lang=js"
export * from "./FreeTourCarousel.vue?vue&type=script&lang=js"
import style0 from "./FreeTourCarousel.vue?vue&type=style&index=0&id=796696c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796696c4",
  null
  
)

export default component.exports